<template>
  <div class="position-relative grey-inputField">
    <img
      class="search-icon"
      src="@/assets/images/common/searchbar-icon.svg"
      alt="search-icon"
    />
    <b-form-input
      class="search-input"
      :placeholder="placeholder"
      type="search"
      debounce="500"
      v-model="searchQuery"
      @focus="sendFocusEvent"
    />
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      searchQuery: this.value || "",
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "Search",
    },
    value: {
      type: String,
      default: "",
    },
  },
  watch: {
    value(newVal) {
      this.searchQuery = newVal;
    },
    searchQuery(val) {
      this.$emit("input", val);
      this.performSearch();
    },
  },
  methods: {
    performSearch() {
      this.$emit("search-data", this.searchQuery);
    },
    sendFocusEvent() {
      this.$emit("focus", this.searchQuery);
    },
    clear() {
      this.searchQuery = "";
      this.performSearch();
    },
  },
};
</script>

<style scoped>
.grey-inputField .search-icon {
  position: absolute;
  top: 10px;
  left: 10px;
}

.grey-inputField .search-input {
  box-sizing: border-box;
  background: rgba(114, 115, 142, 0.08);
  border-radius: 12px;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-400);
  font-size: var(--size-14);
  color: #333333;
  padding: 5px 10px 5px 35px;
  border-color: transparent;
}

.grey-inputField .search-input:focus {
  background: rgba(114, 115, 142, 0.08);
  box-shadow: unset;
  border-color: transparent;
}

.grey-inputField .search-input::placeholder {
  color: #72738e80;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-400);
  font-size: var(--size-14);
}
/* .grey-inputField .form-control {
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-400);
	font-size: var(--size-14);
	color: #5a5a5a;
} */
</style>
